import { useCallback } from 'react';

export const useWindowConfirm = message =>
  // eslint-disable-next-line no-alert
  useCallback(() => window.confirm(message), [message]);
